import React from 'react';
import { Star, StarHalf, User } from 'lucide-react';
import ReviewReplySection from '../../../components/ReviewReplySection';

const ReviewCard = ({ review }) => {
  const renderStars = () => {
    const stars = [];
    const fullStars = Math.floor(review.rating);
    const hasHalfStar = review.rating % 1 !== 0;

    for (let i = 1; i <= 5; i++) {
      if (i <= fullStars) {
        stars.push(
          <Star key={i} className="w-3 h-3 fill-amber-400 text-amber-400" />
        );
      } else if (i === fullStars + 1 && hasHalfStar) {
        stars.push(
          <StarHalf key={i} className="w-3 h-3 fill-amber-400 text-amber-400" />
        );
      } else {
        stars.push(<Star key={i} className="w-3 h-3 text-gray-200" />);
      }
    }
    return stars;
  };

  return (
    <div className="bg-white/60 backdrop-blur-xl rounded-[2.5rem] border border-white/50 p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-500 group flex flex-col justify-between">
      <div>
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center text-primary border border-primary/10 group-hover:bg-primary group-hover:text-white transition-all duration-500">
              <User size={24} />
            </div>
            <div>
              <h3 className="font-black text-gray-900 leading-tight text-sm tracking-tight uppercase">
                {review.booking_id?.name || 'Customer'}
              </h3>
              <p className="text-[10px] text-gray-300 font-bold uppercase tracking-widest mt-0.5">
                {review.booking_id?.phone_number || 'Verified User'}
              </p>
            </div>
          </div>
          <div className="flex flex-col items-end">
            <div className="flex items-center gap-1 bg-amber-50 px-2 py-1 rounded-lg">
              <Star className="w-3 h-3 fill-amber-400 text-amber-400" />
              <span className="text-[10px] font-black text-amber-600">
                {review.rating.toFixed(1)}
              </span>
            </div>
          </div>
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-black text-gray-900 tracking-tight leading-tight group-hover:text-primary transition-colors uppercase">
            {review.title || 'Excellent Experience'}
          </h4>
          <p className="text-xs text-gray-500 font-medium leading-relaxed normal-case first-letter:uppercase">
            {review.description}
          </p>
        </div>
      </div>

      <div>
        <div className="mt-8 pt-6 border-t border-gray-100/50 flex items-center justify-between">
          <div className="flex items-center gap-0.5">
            {renderStars()}
          </div>
          <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">
            {new Date(review.createdAt).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            })}
          </p>
        </div>

        <ReviewReplySection review={review} tokenStorageKey="token_partner_shop" />
      </div>
    </div>
  );
};

export default ReviewCard;
